import woocommerceCheckoutForm from '../modules/woocommerce-checkout-form';

export default {
    init() {
        woocommerceCheckoutForm();
    },
    finalize() {},
};
